// extracted by mini-css-extract-plugin
export var emailInput = "SubscribeForm-module--emailInput--kw6HZ";
export var expandWrapper = "SubscribeForm-module--expandWrapper--F-UJb";
export var form = "SubscribeForm-module--form--l6UAh";
export var formBlock = "SubscribeForm-module--formBlock--2QCkv";
export var formMessage = "SubscribeForm-module--formMessage--URz9l";
export var formMessageError = "SubscribeForm-module--formMessageError--4XUbD";
export var formMessageIcon = "SubscribeForm-module--formMessageIcon--Tyfgf";
export var formStatus = "SubscribeForm-module--formStatus--jeI49";
export var headline = "SubscribeForm-module--headline---Ofuy";
export var intro = "SubscribeForm-module--intro--wPd4l";
export var root = "SubscribeForm-module--root--im7wh";
export var submitButton = "SubscribeForm-module--submitButton--sim8E";
export var textBlock = "SubscribeForm-module--textBlock---2f9N";
export var wrapper = "SubscribeForm-module--wrapper--lJ8l7";